import { Component, OnInit } from '@angular/core';
import { ThemeService } from '../../core/services/theme.service';
import { ActivatedRoute } from '@angular/router';
import { EventTheme } from '../../core/models/event-theme';
import { ExtraService } from '../../core/services/extra.service';
import { Constants } from '../../core/config/Constants';

@Component({
	selector: 'app-theme2',
	templateUrl: './theme2.component.html',
	styleUrls: ['./theme2.component.css']
})
export class Theme2Component implements OnInit {

	buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;
	themes: string = 'THEME0001';
	pageTitle: string = 'Event Theme';
	isError: boolean = false;
	errorMessage: string;
	message: string = '';
	eventID: string;
	primaryArray: Array<any> = [];
	secondaryArray: Array<any> = [];
	eventsTheme = new EventTheme();
	themeArray: Array<any> = [];
	activeExistingThemeTab: boolean = true;
	activeCreateThemeTab: boolean = false;

	previewTheme = {
		existing: {
			primaryColor: '#0c5460',
			secondaryColor: '#0fb3c2'
		},
		custom: {
			primaryColor: '#0c5460',
			secondaryColor: '#FFD31C'
		}
	};

	constructor(private extraService: ExtraService, private eventsThemeService: ThemeService, private route: ActivatedRoute) {
		this.extraService.changeStateofSideBarButton(true);
		this.extraService.changeSideBar(true);
		this.primaryArray = [
			[
				{ color: '#009688', primaryId: 'PRIMARY0001', themeType: 'THEME_TYPE002' },
				{ color: '#007f3e', primaryId: 'PRIMARY0002', themeType: 'THEME_TYPE002' },
				{ color: '#009688', primaryId: 'PRIMARY0003', themeType: 'THEME_TYPE002' },
				{ color: '#0C6164', primaryId: 'PRIMARY0004', themeType: 'THEME_TYPE002' },
				{ color: '#009688', primaryId: 'PRIMARY0005', themeType: 'THEME_TYPE002' }],

			[
				{ color: '#00468C', primaryId: 'PRIMARY0006', themeType: 'THEME_TYPE002' },
				{ color: '#214255', primaryId: 'PRIMARY0007', themeType: 'THEME_TYPE002' },
				{ color: '#32366C', primaryId: 'PRIMARY0008', themeType: 'THEME_TYPE002' },
				{ color: '#0C579D', primaryId: 'PRIMARY0009', themeType: 'THEME_TYPE002' },
				{ color: '#214255', primaryId: 'PRIMARY0010', themeType: 'THEME_TYPE002' }],

			[
				{ color: '#02A4D3', primaryId: 'PRIMARY0011', themeType: 'THEME_TYPE002' },
				{ color: '#02A4D3', primaryId: 'PRIMARY0012', themeType: 'THEME_TYPE002' },
				{ color: '#02A4D3', primaryId: 'PRIMARY0012', themeType: 'THEME_TYPE002' },
				{ color: '#02A4D3', primaryId: 'PRIMARY0014', themeType: 'THEME_TYPE002' },
				{ color: '#02A4D3', primaryId: 'PRIMARY0015', themeType: 'THEME_TYPE002' }],

			[
				{ color: '#B0171F', primaryId: 'PRIMARY0016', themeType: 'THEME_TYPE002' },
				{ color: '#DC143C', primaryId: 'PRIMARY0017', themeType: 'THEME_TYPE002' },
				{ color: '#CD3278', primaryId: 'PRIMARY0018', themeType: 'THEME_TYPE002' },
				{ color: '#CD3278', primaryId: 'PRIMARY0019', themeType: 'THEME_TYPE002' },
				{ color: '#CD3278', primaryId: 'PRIMARY0020', themeType: 'THEME_TYPE002' }],

			[
				{ color: '#765285', primaryId: 'PRIMARY0021', themeType: 'THEME_TYPE002' },
				{ color: '#28063C', primaryId: 'PRIMARY0022', themeType: 'THEME_TYPE002' },
				{ color: '#4A0D4A', primaryId: 'PRIMARY0023', themeType: 'THEME_TYPE002' },
				{ color: '#607D8B', primaryId: 'PRIMARY0024', themeType: 'THEME_TYPE002' },
				{ color: '#607D8B', primaryId: 'PRIMARY0025', themeType: 'THEME_TYPE002' }
			]
		];

		this.secondaryArray = [
			[
				{ color: '#FFD31C', secondaryId: 'SECONDARY0001', themeType: 'THEME_TYPE002' },
				{ color: '#DEB31A', secondaryId: 'SECONDARY0002', themeType: 'THEME_TYPE002' },
				{ color: '#866768', secondaryId: 'SECONDARY0003', themeType: 'THEME_TYPE002' },
				{ color: '#765285', secondaryId: 'SECONDARY0004', themeType: 'THEME_TYPE002' },
				{ color: '#6B82A8', secondaryId: 'SECONDARY0005', themeType: 'THEME_TYPE002' }],

			[
				{ color: '#D73A31', secondaryId: 'SECONDARY0006', themeType: 'THEME_TYPE002' },
				{ color: '#E25F70', secondaryId: 'SECONDARY0007', themeType: 'THEME_TYPE002' },
				{ color: '#FDAE84', secondaryId: 'SECONDARY0008', themeType: 'THEME_TYPE002' },
				{ color: '#E5AF8F', secondaryId: 'SECONDARY0009', themeType: 'THEME_TYPE002' },
				{ color: '#F99797', secondaryId: 'SECONDARY0010', themeType: 'THEME_TYPE002' }],

			[
				{ color: '#B8DDE1', secondaryId: 'SECONDARY0011', themeType: 'THEME_TYPE002' },
				{ color: '#C4D6A4', secondaryId: 'SECONDARY0012', themeType: 'THEME_TYPE002' },
				{ color: '#C4D6A4', secondaryId: 'SECONDARY0013', themeType: 'THEME_TYPE002' },
				{ color: '#C4D6A4', secondaryId: 'SECONDARY0014', themeType: 'THEME_TYPE002' },
				{ color: '#C4D6A4', secondaryId: 'SECONDARY0015', themeType: 'THEME_TYPE002' }],

			[
				{ color: '#C4D6A4', secondaryId: 'SECONDARY0016', themeType: 'THEME_TYPE002' },
				{ color: '#C4D6A4', secondaryId: 'SECONDARY0017', themeType: 'THEME_TYPE002' },
				{ color: '#C4D6A4', secondaryId: 'SECONDARY0018', themeType: 'THEME_TYPE002' },
				{ color: '#C4D6A4', secondaryId: 'SECONDARY0019', themeType: 'THEME_TYPE002' },
				{ color: '#C4D6A4', secondaryId: 'SECONDARY0020', themeType: 'THEME_TYPE002' }]
		];

		this.themeArray = [
			[
				{ primaryValue: '#009688', themeValue: 'THEME0001', secondaryValue: '#FFD31C', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#009688', themeValue: 'THEME0002', secondaryValue: '#866768', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#009688', themeValue: 'THEME0003', secondaryValue: '#6B82A8', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#009688', themeValue: 'THEME0004', secondaryValue: '#D73A31', themeType: 'THEME_TYPE001' },

				{ primaryValue: '#00468C', themeValue: 'THEME0005', secondaryValue: '#DEB31A', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#00468C', themeValue: 'THEME0006', secondaryValue: '#FDAE84', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#00468C', themeValue: 'THEME0007', secondaryValue: '#BAF7BF', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#00468C', themeValue: 'THEME0008', secondaryValue: '#B2B2A2', themeType: 'THEME_TYPE001' }
			],
			[
				{ primaryValue: '#C5050C', themeValue: 'THEME0009', secondaryValue: '#687CB2', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#C5050C', themeValue: 'THEME0010', secondaryValue: '#FFCC00', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#C5050C', themeValue: 'THEME0011', secondaryValue: '#BAF7BF', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#C5050C', themeValue: 'THEME0012', secondaryValue: '#9AABB9', themeType: 'THEME_TYPE001' },

				{ primaryValue: '#CFD58B', themeValue: 'THEME0013', secondaryValue: '#F99797', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#CFD58B', themeValue: 'THEME0014', secondaryValue: '#765285', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#CFD58B', themeValue: 'THEME0015', secondaryValue: '#A8D0E6', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#CFD58B', themeValue: 'THEME0016', secondaryValue: '#F4C20D', themeType: 'THEME_TYPE001' }
			],
			[
				{ primaryValue: '#765285', themeValue: 'THEME0017', secondaryValue: '#E9CC66', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#765285', themeValue: 'THEME0018', secondaryValue: '#F99797', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#765285', themeValue: 'THEME0019', secondaryValue: '#A0C1B8', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#765285', themeValue: 'THEME0020', secondaryValue: '#BAF7BF', themeType: 'THEME_TYPE001' },

				{ primaryValue: '#02A4D3', themeValue: 'THEME0021', secondaryValue: '#E25F70', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#02A4D3', themeValue: 'THEME0022', secondaryValue: '#E9C77B', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#02A4D3', themeValue: 'THEME0023', secondaryValue: '#9AABB9', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#02A4D3', themeValue: 'THEME0024', secondaryValue: '#E2B49A', themeType: 'THEME_TYPE001' }
			],
			[
				{ primaryValue: '#E77200', themeValue: 'THEME0025', secondaryValue: '#C4D6A4', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#E77200', themeValue: 'THEME0026', secondaryValue: '#B8DDE1', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#E77200', themeValue: 'THEME0027', secondaryValue: '#7A6855', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#E77200', themeValue: 'THEME0028', secondaryValue: '#FDD26E', themeType: 'THEME_TYPE001' },

				{ primaryValue: '#032B2F', themeValue: 'THEME0029', secondaryValue: '#FDD26E', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#032B2F', themeValue: 'THEME0030', secondaryValue: '#56B1BF', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#032B2F', themeValue: 'THEME0031', secondaryValue: '#D73A31', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#032B2F', themeValue: 'THEME0032', secondaryValue: '#FDAE84', themeType: 'THEME_TYPE001' }
			],
			[
				{ primaryValue: '#607D8B', themeValue: 'THEME0033', secondaryValue: '#DEB31A', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#607D8B', themeValue: 'THEME0034', secondaryValue: '#FDAE84', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#607D8B', themeValue: 'THEME0035', secondaryValue: '#E25F70', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#607D8B', themeValue: 'THEME0036', secondaryValue: '#B2B2A2', themeType: 'THEME_TYPE001' },

				{ primaryValue: '#60412b', themeValue: 'THEME0037', secondaryValue: '#F99797', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#60412b', themeValue: 'THEME0038', secondaryValue: '#FFCC00', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#60412b', themeValue: 'THEME0039', secondaryValue: '#BAF7BF', themeType: 'THEME_TYPE001' },
				{ primaryValue: '#60412b', themeValue: 'THEME0040', secondaryValue: '#9AABB9', themeType: 'THEME_TYPE001' }
			]
		];


	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			this.getResponse(params['eventId']);
			// let id = params['eventId'];
		});
	}

	getResponse(eventId) {
		this.eventID = eventId;

		this.extraService.setCurrentEventId(eventId);
		this.extraService.changeStateofSideBarButton(true);
		this.extraService.changeSideBar(true);

		this.extraService.setCurrentEventId(eventId);
		if (eventId) {
			this.setEventTheme(eventId);
		}
	}

	setEventTheme(eventId) {
		this.eventsThemeService.getEventTheme(eventId).subscribe(event => {
			if (event) {
				this.eventsTheme = event;
				console.log('Saved Theme :: ', this.eventsTheme);
				this.setPreviewColorOnLoad(event);
			} else {
			}
		});
	}

	submit() {
		this.isError = true;
		if (this.validate()) {
			this.eventsThemeService.updateEventTheme(this.eventsTheme, this.eventID).then(res => {
				this.message = 'Theme Selected Successfully';
			}).catch(error => {
				this.message = error.message;
			});
			this.isError = false;
		} else {
			this.isError = true;
			this.errorMessage = 'Something Went Wrong';
		}
		setTimeout(function () {
			this.message = null;
		}.bind(this), 2000);

		this.setEventTheme(this.eventID);

	}

	validate() {
		if (this.themes) {
			// this.eventsTheme.theme_type = this.themes;
			return true;
		} else {
			return false;
		}
	}

	changePreviewColor(themeProperty: any, changeType: string) {

		switch (changeType) {
			case 'both':
				this.previewTheme.existing.primaryColor = themeProperty.primaryValue;
				this.previewTheme.existing.secondaryColor = themeProperty.secondaryValue;
				console.log('Both Type :: ', themeProperty);

				this.eventsTheme.theme_id = themeProperty.themeValue;
				break;

			case 'primary':
				this.previewTheme.custom.primaryColor = themeProperty.color;
				console.log('Primary Type :: ', themeProperty);
				break;

			case 'secondary':
				this.previewTheme.custom.secondaryColor = themeProperty.color;
				console.log('Secondary Type :: ', themeProperty);
				break;
		}
	}

	private setPreviewColorOnLoad(selectedTheme: EventTheme) {

		this.primaryArray.forEach(row => {
			row.forEach(col => {
				if (col.primaryId === selectedTheme.primary_id) {
					this.previewTheme.custom.primaryColor = col.color;
				}
			});
		});

		this.secondaryArray.forEach(row => {
			row.forEach(col => {
				if (col.secondaryId === selectedTheme.secondary_id) {
					this.previewTheme.custom.secondaryColor = col.color;
				}
			});
		});

		this.themeArray.forEach(selThemeP => {
			selThemeP.forEach(selTheme => {
				if (selTheme.themeValue === selectedTheme.theme_id) {
					this.previewTheme.existing.primaryColor = selTheme.primaryValue;
					this.previewTheme.existing.secondaryColor = selTheme.secondaryValue;
				}
			});
		});

		switch (selectedTheme.theme_type) {
			case Constants.THEME_TYPE_CREATED:
				this.activeExistingThemeTab = false;
				this.activeCreateThemeTab = true;
				break;

			case Constants.THEME_TYPE_EXISTING:
				this.activeExistingThemeTab = true;
				this.activeCreateThemeTab = false;
				break;
		}
	}

	onTabChange(activeTab) {
		switch (activeTab) {
			case Constants.THEME_TYPE_EXISTING:
				this.eventsTheme.theme_type = Constants.THEME_TYPE_EXISTING;
				this.activeExistingThemeTab = true;
				this.activeCreateThemeTab = false;
				break;

			case Constants.THEME_TYPE_CREATED:
				this.eventsTheme.theme_type = Constants.THEME_TYPE_CREATED;
				this.activeExistingThemeTab = false;
				this.activeCreateThemeTab = true;
				break;
		}
	}

}



// WEBPACK FOOTER //
// /app/src/app/event/theme2/theme2.component.ts